import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

// Get system configuration
export const getSystemConfig = async (key: string): Promise<string> => {
  try {
    const response: AxiosResponse<{ value: string }> = await apiClient.get(`/api/config/${key}`);
    return response.data.value;
  } catch (error) {
    console.error(`Error getting system config for ${key}:`, error);
    throw error;
  }
};

// Set system configuration
export const setSystemConfig = async (key: string, value: string): Promise<void> => {
  try {
    await apiClient.post('/api/config', { key, value });
  } catch (error) {
    console.error(`Error setting system config for ${key}:`, error);
    throw error;
  }
};

// Helper for getting default session price
export const getDefaultSessionPrice = async (): Promise<number> => {
  try {
    const response: AxiosResponse<{ defaultPrice: number }> = await apiClient.get('/api/sessions/price/default');
    return response.data.defaultPrice;
  } catch (error) {
    console.error('Error getting default session price:', error);
    throw error;
  }
};

// Helper for setting default session price
export const setDefaultSessionPrice = async (price: number): Promise<void> => {
  try {
    await apiClient.post('/api/sessions/price/default', { price });
  } catch (error) {
    console.error('Error setting default session price:', error);
    throw error;
  }
};